// รายการรถด้านซ้าย — คอลัมน์ สี และการกดเหมือนหน้าเดิม · โหลดข้อมูลที่ Index

import React, { useEffect, useRef } from 'react'
import PropTypes from 'prop-types'
import { Icon, Table, Tag, Tooltip } from 'antd'

const cellStyle = { fontSize: '12px', fontWeight: '400' }
// รถที่อยู่บนจอแล้ว
const selectedStyle = {
  backgroundColor: '#F5F50E',
  color: 'black',
  fontSize: '11px',
  lineHeight: '15px',
  fontWeight: '600',
}

const STATUS_COLOR = {
  running: '#00BF06',
  'stop-with-engine-on': '#ffd619',
  'stop-with-engine-off': '#c91c1c',
  'connection-error': '#848484',
}

// หัวตารางติดบนตอนเลื่อนรายการลง · หัวตาราง antd แบบ small พื้นโปร่งใส จึงใส่สีเดียวกับหัวตารางทั้งแอปเอง
const headerStyle = {
  position: 'sticky',
  top: 0,
  zIndex: 2,
  backgroundColor: '#1890ff',
}
const stickyHeader = () => ({ style: headerStyle })

// ป้ายเฉพาะรถที่พร้อมตาม TOR 2026 (ยิงตรง) · คันอื่นเปิดลิงก์เดิมแบบหน้าเดิม ไม่มีป้าย — ตัดสินที่ VideoWall
const tagStyle = {
  marginTop: '2px',
  marginRight: 0,
  fontSize: '10px',
  lineHeight: '16px',
}

function formatPhone(phone) {
  return phone ? phone.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3') : phone
}

export default function VehicleList({
  vehicles,
  loading,
  selectedIds,
  scrollToId,
  txt,
  onSelect,
}) {
  const wrapper = useRef(null)
  const scrolled = useRef(null)

  // ?vehicle_id= ในลิงก์: เลื่อนไปที่แถวนั้นครั้งเดียว ไม่เลื่อนซ้ำทุกรอบรีเฟรช
  useEffect(() => {
    if (scrollToId == null || scrolled.current === scrollToId || !wrapper.current) return
    const index = vehicles.findIndex(v => v.id === scrollToId)
    const rows = wrapper.current.querySelectorAll('.ant-table-tbody > .ant-table-row')
    if (index < 0 || !rows[index]) return
    rows[index].scrollIntoView({ behavior: 'smooth', block: 'center' })
    scrolled.current = scrollToId
  }, [scrollToId, vehicles])

  const styleOf = record => ({
    style: selectedIds.indexOf(record.id) !== -1 ? selectedStyle : cellStyle,
  })

  const columns = [
    {
      title: <div className="regular-bold-14">#</div>,
      dataIndex: 'row_number',
      width: '10%',
      className: 'column-text-center',
      onHeaderCell: stickyHeader,
      onCell: styleOf,
      render: text => <div style={{ fontSize: '10px' }}>{text}</div>,
    },
    {
      title: <div className="regular-bold-14">{txt.plateNo}</div>,
      dataIndex: 'plate_no',
      width: '42%',
      onHeaderCell: stickyHeader,
      onCell: styleOf,
      render: (text, record) => (
        <div>
          <div style={{ fontSize: '11px' }}>{text}</div>
          <div style={{ fontSize: '14px', fontWeight: 600 }}>
            <Icon type="phone" style={{ transform: 'scaleX(-1)' }} /> :
            {formatPhone(record.phone_number)}
          </div>
        </div>
      ),
    },
    {
      title: <div className="regular-bold-14">{txt.vehicleStatusColumn}</div>,
      dataIndex: 'vehicle_status',
      width: '18%',
      className: 'column-text-center',
      onHeaderCell: stickyHeader,
      onCell: styleOf,
      render: status => (
        <Tooltip
          title={txt.vehicleStatus[status] || txt.vehicleStatus['connection-error']}
          placement="left"
        >
          <Icon
            type="car"
            theme="twoTone"
            twoToneColor={STATUS_COLOR[status] || 'blue'}
            style={{ fontSize: '16px' }}
          />
        </Tooltip>
      ),
    },
    {
      title: <div className="regular-bold-14">{txt.gpsVendor}</div>,
      dataIndex: 'vendor_name',
      width: '30%',
      className: 'column-text-center',
      onHeaderCell: stickyHeader,
      onCell: styleOf,
      render: (text, record) => (
        <div>
          <div style={{ fontSize: '11px' }}>{text}</div>
          {record.is_tor2026_ready === 1 && (
            <Tooltip title={txt.streamHint} placement="left">
              <Tag color="green" style={tagStyle}>
                {txt.streamTag}
              </Tag>
            </Tooltip>
          )}
        </div>
      ),
    },
  ]

  return (
    <div
      ref={wrapper}
      className="lsv2-vehicle-list"
      style={{ height: `${window.innerHeight - 140}px` }}
    >
      <Table
        bordered
        size="small"
        pagination={false}
        columns={columns}
        rowClassName={record => (record.drum_direction === 1 ? 'table-cement' : '')}
        rowKey={record => record.id}
        dataSource={vehicles}
        loading={loading}
        onRow={record => ({ onClick: () => onSelect(record.id) })}
      />
    </div>
  )
}

VehicleList.propTypes = {
  vehicles: PropTypes.array.isRequired,
  loading: PropTypes.bool,
  selectedIds: PropTypes.array.isRequired,
  /** id จาก ?vehicle_id= ในลิงก์ */
  scrollToId: PropTypes.number,
  txt: PropTypes.object.isRequired,
  onSelect: PropTypes.func.isRequired,
}
